import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { usePermission } from "../../hooks/usePermission";
import UserProfile from '../../assets/images/setting.png';
import Clock from 'react-live-clock';
import { getRoleName } from "../../components/Utils";
import { PiCrown } from "react-icons/pi";

const NavBar = () => {
  const [menuActive, setMenuActive] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { hasPermission } = usePermission();
  const navigate = useNavigate();
  const menuRef = useRef(null);
  const navRef = useRef(null);

  const auth_user = JSON.parse(localStorage.getItem("user"));

  // Close profile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuActive(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Responsive clock: detect screen width changes
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Blur effect on navbar when page is scrolled
  useEffect(() => {
    const handleScroll = () => {
      const nav = navRef.current;
      if (!nav) return;
      if (window.scrollY > 10) {
        nav.classList.add('navbar-scrolled');
      } else {
        nav.classList.remove('navbar-scrolled');
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openDrawer = () => {
    let html = document.querySelector('html');
    html.classList.add('layout-menu-expanded');
  };

  const openMenu = () => {
    setMenuActive(true);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <nav
      ref={navRef}
      className="layout-navbar navbar navbar-expand-xl align-items-center bg-navbar-theme navbar-padding"
      id="layout-navbar"
    >
      <div
        onClick={openDrawer}
        className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none"
      >
        <i className="bx bx-menu bx-sm"></i>
      </div>
      <div className="container">
        <div className="">
          <h3 className="welcome-text">Hi, <span style={{ textTransform: 'capitalize' }}>{auth_user?.name}</span></h3>
        </div>
      </div>
      <div className="container">
        <div className="clock-container text-center w-100">
          <div className="digital-clock">
            <Clock
              format={isMobile ? 'DD/MM hh:mm A' : 'DD/MM/YYYY hh:mm:ss A'}
              ticking={true}
              timezone={'Asia/Kolkata'}
            />
          </div>
        </div>
      </div>
      <div className="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
        <div className="user_icon">
          <div className="action">
            <div className="profile">
              <img src={UserProfile} alt="icon" onClick={openMenu} />
            </div>
            <div ref={menuRef} className={`menu ${menuActive ? 'active' : ''}`}>
              <div className='profile_menu'>
                <div className='user_info'>
                  <h5>{auth_user?.name}</h5>
                  <p>{auth_user?.email}</p>
                  <p>{getRoleName(auth_user?.user_type)} <PiCrown className="crown-icon" /></p>
                </div>
                <div className='p_menu_list'>
                  <ul>
                    <li>
                      <Link to="change-password" >Change Password</Link>
                    </li>
                    {hasPermission("settings-list") && (
                    <li>
                      <Link to="settings" >Settings</Link>
                    </li>
                    )}
                  </ul>
                </div>
                <div className='profile_logout'>
                  <a href="#" onClick={logout}>
                    Logout
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
